import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
/**静态实体类 */
export class StaticService {

  constructor() { }
}
 /**
  * http请求Header头配置
  */
 export const HttpHeader={
  'Content-Type': 'application/json; charset=UTF-8',
  'Access-Control-Allow-Origin':'*',
  'Access-Control-Allow-Methods':'POST',
  'Access-Control-Allow-Headers':'x-requested-with, Content-Type',
  'x-requested-with':'XMLHttpRequest',
  'Authorization':'Bearer '
 }